import { unitHasOwner, unitSelectLabel } from './servicePackages/formShared';

export const propertyIdOfUnit = unit => {
  const property = unit && unit.roomType && unit.roomType.property;
  if (!property) return '';
  if (typeof property === 'object') return String(property._id || '');
  return String(property);
};

export const unitMetaFromHostUnits = (hostUnits = []) => {
  const unitNameById = {};
  const propertyIdByUnitId = {};
  (hostUnits || []).forEach(u => {
    if (!u || u._id == null) return;
    const id = String(u._id);
    unitNameById[id] = u.name || id;
    const propertyId = propertyIdOfUnit(u);
    if (propertyId) propertyIdByUnitId[id] = propertyId;
  });
  return { unitNameById, propertyIdByUnitId };
};

export const unitsForProperty = (hostUnits, propertyId) => {
  if (!propertyId) return [];
  return (hostUnits || []).filter(u => propertyIdOfUnit(u) === String(propertyId));
};

export const installmentUnitOption = unit => ({
  key: String(unit && unit._id),
  value: String(unit && unit._id),
  disabled: !unitHasOwner(unit),
  label: unitSelectLabel(unit),
});

export const filterInstallmentsByProperty = (rows, propertyId, propertyIdByUnitId) => {
  const list = rows || [];
  if (!propertyId) return list;
  const map = propertyIdByUnitId || {};
  return list.filter(r => String(map[String(r.unitId)] || '') === String(propertyId));
};
